/* tslint:disable */
/* eslint-disable */
import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ActuatorService } from './services/actuator.service';
import { RotorWingFormsWriteService } from './services/rotor-wing-forms-write.service';
import { RotorWingFormsService } from './services/rotor-wing-forms.service';
import { FixedWingFormsWriteService } from './services/fixed-wing-forms-write.service';
import { FixedWingFormsService } from './services/fixed-wing-forms.service';
import { OperationFormsService } from './services/operation-forms.service';
import { ClinicalDepartmentFormsService } from './services/clinical-department-forms.service';
import { ClinicalDepartmentFormsWriteService } from './services/clinical-department-forms-write.service';
import { OperationFormsWriteService } from './services/operation-forms-write.service';
import { CustomerSurveyFormsService } from './services/customer-survey-forms.service';
import { CustomerSurveyFormsWriteService } from './services/customer-survey-forms-write.service';
import { ClinicalDashboardService } from './services/clinical-dashboard.service';
import { FormMetadataService } from './services/form-metadata.service';
import { WorkflowCallbackService } from './services/workflow-callback.service';
import { ClinicalWorkflowRecoveryService } from './services/clinical-workflow-recovery.service';
import { ClinicalSessionService } from './services/clinical-session.service';
import { WmsWorkflowProxyService } from './services/wms-workflow-proxy.service';
import { ClinicalWmsWorkflowBffService } from './services/clinical-wms-workflow-bff.service';
import { LegacyImportService } from './services/legacy-import.service';
import { ClinicalCustomerNamesService } from './services/clinical-customer-names.service';
import { ClinicalApprovedOverrideService } from './services/clinical-approved-override.service';
import { FormFieldImagesService } from './services/form-field-images.service';
import { FormDuplicateSourcesService } from './services/form-duplicate-sources.service';
import { FormCrossFormDuplicateSourcesService } from './services/form-cross-form-duplicate-sources.service';
import { FormPriorFieldContextService } from './services/form-prior-field-context.service';
import { SubmissionHistoryService } from './services/submission-history.service';
import { PerformanceProgramsService } from './services/performance-programs.service';
import { PerformanceRemarksService } from './services/performance-remarks.service';
import { PerformanceTicketsService } from './services/performance-tickets.service';
import { PerformanceActionsService } from './services/performance-actions.service';
import { PerformancePostFlightSourcesService } from './services/performance-post-flight-sources.service';
import { PerformanceDashboardService } from './services/performance-dashboard.service';
import { ClinicalPrivilegeFormCategoriesService } from './services/clinical-privilege-form-categories.service';
import { ClinicalPrivilegeCategoriesService } from './services/clinical-privilege-categories.service';
import { ClinicalPrivilegeCatalogService } from './services/clinical-privilege-catalog.service';
import { ClinicalPrivilegeAssignmentsService } from './services/clinical-privilege-assignments.service';
import { ClinicalLicenseRanksService } from './services/clinical-license-ranks.service';
import { ClinicalLicenseRequestsService } from './services/clinical-license-requests.service';
import { ClinicalLicenseMailSubscribersService } from './services/clinical-license-mail-subscribers.service';
import { ClinicalPrivilegeNotificationSubscribersService } from './services/clinical-privilege-notification-subscribers.service';
import { ClinicalPrivilegeNotificationsService } from './services/clinical-privilege-notifications.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ActuatorService,
    RotorWingFormsWriteService,
    RotorWingFormsService,
    FixedWingFormsWriteService,
    FixedWingFormsService,
    OperationFormsService,
    ClinicalDepartmentFormsService,
    ClinicalDepartmentFormsWriteService,
    OperationFormsWriteService,
    CustomerSurveyFormsService,
    CustomerSurveyFormsWriteService,
    ClinicalDashboardService,
    FormMetadataService,
    WorkflowCallbackService,
    ClinicalWorkflowRecoveryService,
    ClinicalSessionService,
    WmsWorkflowProxyService,
    ClinicalWmsWorkflowBffService,
    LegacyImportService,
    ClinicalCustomerNamesService,
    ClinicalApprovedOverrideService,
    FormFieldImagesService,
    FormDuplicateSourcesService,
    FormCrossFormDuplicateSourcesService,
    FormPriorFieldContextService,
    SubmissionHistoryService,
    PerformanceProgramsService,
    PerformanceRemarksService,
    PerformanceTicketsService,
    PerformanceActionsService,
    PerformancePostFlightSourcesService,
    PerformanceDashboardService,
    ClinicalPrivilegeFormCategoriesService,
    ClinicalPrivilegeCategoriesService,
    ClinicalPrivilegeCatalogService,
    ClinicalPrivilegeAssignmentsService,
    ClinicalLicenseRanksService,
    ClinicalLicenseRequestsService,
    ClinicalLicenseMailSubscribersService,
    ClinicalPrivilegeNotificationSubscribersService,
    ClinicalPrivilegeNotificationsService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(
    params: ApiConfigurationParams
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
